/* eslint-disable */ 
import { URL } from '../../../config'
import { getRequest } from '../../../utils/functions/httpRequest'

export const getEventAverageBySeason = function (seasonId,eventId) 
{
    const endpoint = `/${seasonId}/${eventId}/eventaverage`
    const rankingURL = `${URL.ranking}${endpoint}` 
    return getRequest(rankingURL)
} 


// WEBPACK FOOTER //
// ./src/components/pages/api/getEventAverageBySeason.js